import { AfterViewInit, Component, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { TIconSize, TIconType } from '../icon/icon.types';
import { TCaptionAvatarAlign, TCaptionAvatarSize, TCaptionSmallTextSize } from './caption.types';

@Component({
	selector: 'rbc-caption',
	templateUrl: './caption.component.html',
	styleUrls: ['./caption.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CaptionComponent implements AfterViewInit, OnDestroy {
	@Input() avatarAlign: TCaptionAvatarAlign = 'center';
	@Input() avatarColor: string;
	@Input() avatarSize: TCaptionAvatarSize = 'small';
	@Input() avatarText: string;
	@Input() avatarTextColor: string;
	@Input() circle: boolean = true;
	@Input() icon: string;
	@Input() iconSize: TIconSize = 'normal-size';
	@Input() iconWeight: TIconType = 'regular';
	@Input() id: string;
	@Input() image: string;
	@Input() imageText: string;
	@Input() link: string;
	@Input() linkLabel: string;
	@Input() routerTo: string;
	@Input() smallText: string;
	@Input() smallTextSize: TCaptionSmallTextSize = 'small';
	@Input() text: string;

	@ViewChild('default') $defaultContent;
	@ViewChild('headerText') $headerContent;

	defaultContentPresent = false;
	headerContentPresent = true;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (this.$defaultContent.nativeElement.childElementCount > 0) {
				this.defaultContentPresent = true;
			}
			if (this.$headerContent.nativeElement.childElementCount <= 0) {
				this.headerContentPresent = false;
			}
		});
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	avatarClassGen() {
		const color = this.avatarTextColor ? this.avatarTextColor : this.avatarColor ? 'white' : null;
		return {
			'caption-avatar-circle': this.circle,
			'caption-avatar-transparent': !this.circle,
			[`caption-avatar-${this.avatarSize}`]:
				this.avatarSize === 'small' ||
				this.avatarSize === 'large' ||
				this.avatarSize === 'xlarge' ||
				this.avatarSize === 'xxlarge',
			[`b-${this.avatarColor}`]: this.avatarColor,
			[`c-${color}`]: color
		};
	}
}
